import React from 'react';
import ReactDOM from 'react-dom';
import 'moment/min/locales';
import './index.css';
import './scss/app.scss';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { CookiesProvider } from 'react-cookie';
import store from './utils/store';
import * as serviceWorker from './serviceWorker';
import Router from './pages/Router';
import ErrorBoundary from './components/ErrorBoundary';

ReactDOM.render(
  <CookiesProvider>
    <Provider store={store}>
      <BrowserRouter>
          <ErrorBoundary>
            <Router />
          </ErrorBoundary>
      </BrowserRouter>
    </Provider>
  </CookiesProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
